import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const MATCH_URL = 'docs.google.com';
const DOCUMENT_PATTERN = /(document)\/d\/([^/]+)&?/;
const PRESENTATION_PATTERN = /(presentation)\/d\/([^/]+)&?/;
const EMBED_BASE = '//docs.google.com/';

const DEFAULT_WIDTH = '768px';
const DEFAULT_HEIGHT = '342px';

export const matchGoogleDocs: ProviderMatcher = (url, params) => {
	if (!url.includes(MATCH_URL)) {
		return null;
	}
	let embedUrl: string | null = null;
	for (const pattern of [DOCUMENT_PATTERN, PRESENTATION_PATTERN]) {
		const match = pattern.exec(url);
		if (match) {
			const docType = match[1];
			const docId = match[2];
			embedUrl = `${EMBED_BASE}${docType}/d/${docId}`;
			if (docType === 'presentation') {
				embedUrl += '/embed';
			} else if (docType === 'document') {
				embedUrl += '/pub?embedded=true';
			}
			break;
		}
	}
	if (!embedUrl) {
		return null;
	}
	return {
		kind: 'iframe',
		provider: 'Google Docs',
		embedUrl,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
